import '../Default/Default.css';
import AnimatedLogo from '../../components/AnimatedLogo/AnimatedLogo';
import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { PowerBIEmbed } from 'powerbi-client-react';
import * as powerbi from 'powerbi-client';
import SideMenu from '../../components/SideMenu/SideMenu';
import { useAuth } from '../../hooks/useAuth';

const REPORT_ID = 'a9b5859b-fa08-4c97-ae6a-87adb5e79504';
const Helios = () => {
  const navigate = useNavigate();
  const { token, error: authError, loading } = useAuth();

  const [showLogo, setShowLogo] = useState(true);
  const [isPortrait, setIsPortrait] = useState(false);
  const [embedConfig, setEmbedConfig] = useState(null);
  const [embedError, setEmbedError] = useState(null);
  const [reportLoaded, setReportLoaded] = useState(false);

  const checkOrientation = () => {
    const isPortraitOrientation = window.matchMedia('(orientation: portrait)').matches;
    setIsPortrait(isMobile && isPortraitOrientation);
  };

  useEffect(() => {
    checkOrientation();
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);
    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);

  useEffect(() => {
    if (authError) {
      console.error('Error de autenticación:', authError);
      setEmbedError('No estás autorizado para ver este reporte.');
      setShowLogo(false);
    }
  }, [authError]);

  useEffect(() => {
    if (token) {
      loadReport(token);
    }
  }, [token]);

  useEffect(() => {
    if (embedError) {
      const redirectTimer = setTimeout(() => {
        navigate('/');
      }, 4000);
      return () => clearTimeout(redirectTimer);
    }
  }, [embedError, navigate]);

  useEffect(() => {
    if (reportLoaded) {
      const hideTimer = setTimeout(() => {
        setShowLogo(false);
      }, 500);
      return () => clearTimeout(hideTimer);
    }
  }, [reportLoaded]);

  const loadReport = async (accessToken) => {
    try {
      const apiResponse = await fetch(
        `https://api.powerbi.com/v1.0/myorg/reports/${REPORT_ID}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!apiResponse.ok) {
        throw new Error(`API Error: ${apiResponse.status} - ${apiResponse.statusText}`);
      }

      const reportData = await apiResponse.json();
      if (!reportData.embedUrl) {
        throw new Error('No se encontró embedUrl en la respuesta de la API');
      }

      setEmbedConfig({
        type: 'report',
        id: REPORT_ID,
        embedUrl: reportData.embedUrl,
        accessToken,
        tokenType: powerbi.models.TokenType.Aad,
        settings: {
          panes: {
            filters: { visible: false },
            navigation: { visible: false },
            pageNavigation: { visible: false },
          },
        },
      });
    } catch (err) {
      console.error('Error al cargar reporte:', err);
      setEmbedError('No estás autorizado para ver este reporte.');
      setShowLogo(false);
    }
  };

  return (
    <div className="container">
      <AnimatedLogo visible={showLogo} />

      {!showLogo && embedError && (
        <div className="error-overlay">
          <p>{embedError}</p>
        </div>
      )}

      {!embedError && embedConfig && embedConfig.accessToken && (
        <div className="iframe-container">
          <SideMenu />
          <PowerBIEmbed
            embedConfig={embedConfig}
            cssClassName="iframe-container"
            style={{ height: '100vh', width: '100%' }}
            eventHandlers={
              new Map([
                ['loaded', () => setReportLoaded(true)],
                [
                  'error',
                  (event) => {
                    console.error('Error en el embed:', event.detail);
                    setEmbedError('No estás autorizado para ver este reporte.');
                    setShowLogo(false);
                  },
                ],
              ])
            }
          />
        </div>
      )}

      {isPortrait && (
        <div className="rotate-message">
          <p>Rota tu pantalla a modo horizontal para una mejor experiencia.</p>
        </div>
      )}
    </div>
  );
};

export default Helios;